import { faTrash } from "@fortawesome/fontawesome-free-solid";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PlusIcon } from "@heroicons/react/solid";
import { isNumber } from "lodash";
import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "../../../components/b2b/Modal";
import SideBar from "../../../components/b2b/SideBar";
import Header from "../../../components/landingPage/Header";
import { Link } from "react-router-dom";
import { Skeleton } from "@mui/material";

const CreditCards = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { allCreditCards, creditcardLoading } = useSelector(
    (state) => state.creditcard
  );
  const [addCardModal, setaddCardModal] = useState(false);
  const cardPayload = useRef({
    cardNumberLastFour: "",
    name: "",
    bank: "",
  });
  const [isDelete, setisDelete] = useState();

  useEffect(() => {
    dispatch({
      type: "GET_ALL_CREDIT_CARDS",
      payload: {
        token,
      },
    });
  }, []);

  return (
    <div className="h-screen w-screen fixed ">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className=" w-full">
          <div className="flex justify-between ">
            {addCardModal && (
              <>
                <div className="fixed top-0 left-0 w-screen h-screen bg-black bg-opacity-50 z-50">
                  <Modal
                    heading="Add Card"
                    cancelOnClick={() => {
                      setaddCardModal(false);
                    }}
                    addOnClick={() => {
                      if (
                        !isNumber(
                          parseInt(cardPayload.current.cardNumberLastFour)
                        )
                      ) {
                        toast.warn("Card number must be a number!");
                      } else if (
                        cardPayload.current.cardNumberLastFour === "" ||
                        cardPayload.current.name === "" ||
                        cardPayload.current.bank === ""
                      ) {
                        toast.warn("All fields are required!");
                      } else {
                        dispatch({
                          type: "ADD_CREDIT_CARD",
                          payload: {
                            token,
                            body: cardPayload.current,
                          },
                        });
                        setaddCardModal(false);
                      }
                    }}
                    addButtonLabel="Add"
                    isAddCard={true}
                    cardNumberInput={(e) => {
                      cardPayload.current.cardNumberLastFour = e.target.value;
                    }}
                    cardHolderNameInput={(e) => {
                      cardPayload.current.name = e.target.value;
                    }}
                    cardBankNameInput={(e) => {
                      cardPayload.current.bank = e.target.value;
                    }}
                  />
                </div>
              </>
            )}
            <div className="flex justify-between  w-full mx-10 mt-3">
              <div></div>
              <div
                onClick={() => {
                  setaddCardModal(true);
                }}
                className="flex px-3 py-2 space-x-1 text-sm rounded-md cursor-pointer  bg-secondary hover:bg-gray-300 hover:text-black text-white mr-5"
              >
                <PlusIcon className="w-5" />
                <div className="font-body">Add Card</div>
              </div>
            </div>
          </div>
          <div className="  h-[80vh] overflow-y-auto px-10 scrollbar mt-10">
            <div className="grid md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-5">
              {!creditcardLoading ? (
                allCreditCards?.map((card) => {
                  return (
                    <CreditCardsItem
                      key={card?.id}
                      id={card?._id}
                      cardNumber={card?.cardNumberLastFour}
                      holderName={card?.name}
                      bankName={card?.bank}
                      deleteOnclick={() => {
                        setisDelete(card?._id);
                      }}
                      editOnclick={() => {}}
                      isDelete={isDelete}
                      deleteStatusNo={() => {
                        setisDelete(null);
                      }}
                      deleteStatusYes={() => {
                        dispatch({
                          type: "DELETE_CREDIT_CARD",
                          payload: {
                            token,
                            id: card?._id,
                          },
                        });
                        setisDelete(null);
                      }}
                    />
                  );
                })
              ) : (
                <>
                  <div className="px-10 space-y-5 ">
                    <div className="border px-10 py-5 rounded-md grow">
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </div>
                    <div className="border px-10 py-5 rounded-md grow">
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </div>

                    <div className="border px-10 py-5 rounded-md">
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditCards;

export const CreditCardsItem = ({
  id,
  deleteOnclick,
  editOnclick,
  cardNumber,
  holderName,
  bankName,
  isDelete,
  deleteStatusNo,
  deleteStatusYes,
}) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  return (
    <div className="border-[#1e201e] space-y-3 border h-auto text-gray-700 rounded-md">
      <Link to={`/creditcard/${id}`}>
        <div className="p-3">
          <div className="sm:flex sm:space-x-2 lg:flex xl:space-x-1 items-center">
            <div className="text-xs font-body">Card Number: </div>
            <div className="font-semibold font-body">
              xxxx-xxxx-xxxx-{cardNumber}
            </div>
          </div>
          <div className="space-y-2 mt-2">
            <div className="sm:flex sm:space-x-2 lg:flex xl:space-x-1 items-center ">
              <div className="text-xs font-body">Holder&nbsp;Name: </div>
              <div className="uppercase text-sm font-body">{holderName}</div>
            </div>
            <div className="sm:flex sm:space-x-2 lg:flex xl:space-x-1 items-center">
              <div className="text-xs  font-body">Bank&nbsp;Name: </div>
              <div className=" uppercase text-sm  font-body">{bankName}</div>
            </div>
          </div>
        </div>
      </Link>
      <div className="relative">
        <div className="flex justify-end border-t space-x-5 border-gray-200 px-3 py-1">
          <div className="cursor-pointer ">
            <FontAwesomeIcon
              onClick={deleteOnclick}
              icon={faTrash}
              className="text-red-700  text-xs"
            />
          </div>
          <div onClick={editOnclick} className="cursor-pointer">
            <FontAwesomeIcon
              icon={faPencil}
              className="text-teal-700 text-xs"
            />
          </div>
        </div>
        {isDelete === id && (
          <div className="bg-white pl-3 text-sm text-red-500 absolute top-0 font-body border-t border-gray-200 w-full">
            Do you want to delete this card?{" "}
            <button
              onClick={deleteStatusNo}
              className="text-gray-700 px-2 py-1 rounded-md hover:bg-gray-500 hover:text-white font-body"
            >
              No
            </button>
            <button
              onClick={deleteStatusYes}
              className="text-red-700 px-2 py-1 rounded-md hover:bg-red-500 hover:text-white font-body"
            >
              Yes
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
